import React, { useState, useEffect } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Button } from 'telstra-ui/components/button/Button';
import { Tag } from 'telstra-ui/components/tag/Tag';
import { prepareDropDownOptionsArry } from '../../amp-homepage.actions';
import './add-on-filters.css';

const AddOnFilters = (props) => {
  const {
    authorableContent: {
      filterHeading,
      filterSelectPlans,
      filterApply,
      filterCancel,
      planName,
      formFields: {
        addOnPlans,
      },
    },
    filterOpen,
    filterApplied,
    applyFilter,
    cancelFilter,
    filterClearAll,
  } = props;

  const [recommendPlanSearch, setRecommendPlanSearch] = useState([]);
  const recommendPlanDropDownOptionsVal = addOnPlans.options;
  const recommendPlanDropDownOptions = prepareDropDownOptionsArry(recommendPlanDropDownOptionsVal);
  const [recommendPlanSearchSelected, setRecommendPlanSearchSelected] = useState([]);

  useEffect(() => {
    setRecommendPlanSearch(recommendPlanDropDownOptions);
  }, [addOnPlans.options]);

  useEffect(() => {
    if (filterClearAll) {
      setRecommendPlanSearchSelected([]);
    }
  }, [filterClearAll]);

  const selectRecommendPlanSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = recommendPlanDropDownOptions.find(itm => itm.itemId === selectedDevice);
    if (deviceText && recommendPlanSearchSelected.includes(deviceText.displayText) === false) {
      const selectedDevices = [...recommendPlanSearchSelected, deviceText.displayText];
      setRecommendPlanSearchSelected(selectedDevices);
    }
  };

  const removeFilterSelectionRecommendPlan = (val) => {
    const selectedDevices = recommendPlanSearchSelected.filter(itm => itm !== val);
    if (selectedDevices) {
      setRecommendPlanSearchSelected(selectedDevices);
    }
  };

  const searchPlanBox = (event, dropDownOptions, planSearch) => {
    const searchText = event.target.value.toLowerCase();
    const desiredText = searchText.replace(/[-[\]`~@#%!'=_&";:/.>,<{}()*+?.,\\^$|#]/g);
    const options = dropDownOptions.filter((option) => {
      const optionText = option.displayText.toLowerCase();
      const match = optionText.match(desiredText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    planSearch(options);
  };

  const onTagClose = (e) => {
    const idValue = e.target.parentNode.id;
    const [devType, devValue] = idValue.split('|');
    const filterObj = {};

    if (devType === 'recommendPlan') {
      const recommendedPlans = recommendPlanSearchSelected.filter(itm => itm !== devValue);
      setRecommendPlanSearchSelected(recommendedPlans);
      filterObj.recommendPlanSelectId = recommendedPlans.map((itm) => {
        const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
        return device.itemId;
      });
    } else {
      filterObj.recommendPlanSelectId = recommendPlanSearchSelected.map((itm) => {
        const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
        return device.itemId;
      });
    }

    if (filterObj.recommendPlanSelectId.length === 0) {
      cancelFilter();
    } else {
      applyFilter(filterObj);
    }
  };

  const applyCancel = () => {
    setRecommendPlanSearchSelected([]);
    cancelFilter();
  };

  const generateFilterTags = () => {
    let allTags = [];

    const recommendedPlans = recommendPlanSearchSelected.map(dev => (
      {
        devType: 'recommendPlan',
        devValue: dev,
      }
    ));

    allTags = [...allTags, ...recommendedPlans];

    return (
      allTags.map((tag, index) => (
        <div className="tag-box" key={`tag${index + 1}`}>
          <Tag
            label={tag.devValue}
            icon="icon-navigation-close"
            iconPosition="right"
            id={`${tag.devType}|${tag.devValue}`}
            onCloseClick={onTagClose}
          />
        </div>
      ))
    );
  };

  const applyFilterSelected = () => {
    const recommendPlanSelectId = recommendPlanSearchSelected.map((itm) => {
      const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
      return device.itemId;
    });
    const filterArr = {
      recommendPlanSelectId,
    };
    applyFilter(filterArr);
  };

  return (
    <div className="addon-filter-section">
      {filterOpen === false && filterApplied &&
        <div className="row">
          {generateFilterTags()}
        </div>
      }
      {filterOpen &&
        <div className="main-filter">
          <div className="row">
            <div className="col-12 heading20">
              {filterHeading}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Dropdown
                dropdownId="filter-recommend-plan"
                label={planName}
                values={recommendPlanSearchSelected}
                searchOnChange={e => searchPlanBox(e, recommendPlanDropDownOptions, setRecommendPlanSearch)}
                multiSelection
                removeFilterSelection={removeFilterSelectionRecommendPlan}
                searchBox
                highlightSelected
                options={recommendPlanSearch}
                onOptionClick={selectRecommendPlanSearchOption}
                assistiveText={filterSelectPlans}
              />
            </div>
          </div>
          <div className="row buttons-row" >
            <div className="col-3 offset-9">
              <div className="row">
                <div className="col-6">
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => applyCancel()}
                  >{filterCancel}
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    variant="primary"
                    size="small"
                    state="app"
                    onClick={() => applyFilterSelected()}
                  >{filterApply}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default AddOnFilters;
